(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["kp-harness-purchase"] && !Shopify.designMode) return;
  try {
    document.addEventListener('change', function(event) {
  const selected = event.target;
  if (!selected.matches('.kp-harness-form input[type="radio"][name="id"]')) return;
  document.querySelectorAll('.kp-harness-form').forEach(function(form) {
    form.querySelectorAll('input[type="radio"][name="id"]').forEach(function(input) {
      input.checked = input.value === selected.value;
    });
    const current = form.querySelector('input[type="radio"]:checked');
    form.querySelector('button[type="submit"]').disabled = !current || current.dataset.available !== 'true';
  });
});
  } catch(e) { console.error(e); }
})();

})();
